import { useMemo, useContext } from 'react';

import { defaultTranslation } from './constant';
import { TranslationContext } from './translationContext';

function useTableTranslation() {
  const translation = useContext(TranslationContext);

  const allTranslations = useMemo(() => ({ ...defaultTranslation, ...translation }), [translation]);

  return allTranslations;
}

export { useTableTranslation };
